module.exports = __webpack_public_path__ + "static/media/artboard-cs.1966d946.jpg";